import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { TopicAnswers, User } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class CourseService {

    constructor(private http: HttpClient) { }
    getOverview(id) {
        return this.http.get<any>(`${environment.apiUrl}/courses/overview/${id}`);
    }

    getAssessmentAnswers(){
        return this.http.get<any>(`${environment.apiUrl}/courses/assessment-answers/`);
    }

    getSection(id) {
        return this.http.get<any>(`${environment.apiUrl}/courses/part-section/${id}`);
    }

    getSectionData(id) {
        return this.http.get<any>(`${environment.apiUrl}/courses/part-section-data/${id}`);
    }

    getIntro(id) {
        return this.http.get<any>(`${environment.apiUrl}/courses/part-intro/${id}`);
    }

    getTopic(id) {
        return this.http.get<any>(`${environment.apiUrl}/courses/part-section/${id}`);
    }

    getCourseContinue(id) {
        return this.http.get<any>(`${environment.apiUrl}/courses-continue/${id}`);
    }

    getCoursesProgress() {
        return this.http.get<any>(`${environment.apiUrl}/courses/all-progress`);
    }
    
    getIntroId(courseId){
        return this.http.get<any>(`${environment.apiUrl}/courses/${courseId}/intro`)
    }

    postAnswers(sectionId:any, answers: TopicAnswers) {

        var userAnswers = answers.answers.map(a => {
            return { questionId: a.questionId, answer: a.answer, answerId: a.answerId, assessmentId: a.assessmentId, reflection: a.reflection }
        });

        var body = {
            answers: userAnswers
        };

        return this.http.post(`${environment.apiUrl}/courses/add-progress/${sectionId}?finished=true`, body);
    }

    addProgress(sectionId) {
        return this.http.post(`${environment.apiUrl}/courses/add-progress/${sectionId}?finished=true`, {});
    }

    getDashboard(){
        return this.http.get<any>(`${environment.apiUrl}/dashboard/my`);
    }

    getJourney(){
        return this.http.get<any>(`${environment.apiUrl}/dashboard/my/journey`);
    }

    addPreCourseEvent(courseId, component){
        var body = {
            component: component
        };
        return this.http.post(`${environment.apiUrl}/courses/add-precourse-event/${courseId}`, body);
    }

    getPreviousSection(currentSectionId) {
        return this.http.get<any>(`${environment.apiUrl}/courses/previous-section/${currentSectionId}`);
    }

    getCourse(courseId) {
        return this.http.get<any>(`${environment.apiUrl}/courses/${courseId}`);
    }
}